var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c-dropdown",class:{
    'is-invalid': _vm.invalid,
    'tw-w-full': _vm.fullwidth,
    disabled: _vm.disabled,
  }},[_c('select',{class:{
      'form-select sm:tw-text-sm sm:tw-leading-5 tw-ps-3 tw-pe-10 tw-rounded-md': true,
      'tw-w-full': _vm.fullwidth,
      'tw-border-danger': _vm.invalid,
      'tw-border-field': !_vm.invalid,
    },attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event.target.value)}}},_vm._l((_vm.options),function(option,key){return _c('option',{key:key,domProps:{"value":option.value}},[_vm._v("\n      "+_vm._s(option.label)+"\n    ")])}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }